import { Button, Card, CardMedia, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useStylesCardGlobal } from '../../../../styles/global/cardStyles';
import { formatEllipsis } from '../../../../util/commons';
import CardPlanAmountsSection from './CardPlanAmountsSection/';
import CardPlanAmountTypeSection from './CardPlanAmountTypeSection/';
import { useStyles } from './styles';

type Props = {
  infoToContract: any;
  businessPlanName: string;
};
const CardHirePlanMobileWithImage: FC<Props> = ({ infoToContract, businessPlanName }) => {
  const classes = useStyles();
  const classesCardGlobal = useStylesCardGlobal();
  const { t } = useTranslation();

  const handleDownload = () => {
    window.open(infoToContract?.infoPlan.urlPlan);
  };

  return (
    <Grid item xs={12} className={classesCardGlobal.showMobilePlanCard}>
      <Card className={classes.infoPlanCard}>
        <CardMedia
          component={'img'}
          alt={businessPlanName}
          image={infoToContract?.infoPlan.imageUrl}
          classes={{
            media: classes.img,
          }}
        />
        <div className={classes.column}>
          <Typography className={classes.name}>{formatEllipsis(businessPlanName, 70)}</Typography>
        </div>
        <div className={classes.columnButton}>
          <Button
            variant="outlined"
            className={classesCardGlobal.button}
            onClick={handleDownload}
            size={'small'}
          >
            {t('Descargar plan')}
          </Button>
        </div>
        <div className={classes.columnPriceType}>
          <CardPlanAmountTypeSection item={infoToContract?.infoPlan} />
        </div>
        <div className={classes.columnPrice}>
          <CardPlanAmountsSection item={infoToContract?.infoPlan} />
        </div>
      </Card>
    </Grid>
  );
};

export default CardHirePlanMobileWithImage;
